module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07447_banner_800x600.07f8d72b.png";